
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Regular","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M.75 12L6 2.25h12.75l4.5 9.75-4.5 9.75H6L.75 12z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.75 6.75l-9 5.25 9 4.5V6.75zM18.75 2.25l-3 4.5 7.5 5.25-7.5 4.5 3 5.25"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.75 6.75L6 2.25 6.75 12h-6M6.75 12L6 21.75l9.75-5.25"}})])
          )
        }
      }
    